import { ImageCardBase as _ImageCard } from './ImageCard';
import { ImageCardMetadata } from './ImageCard.Metadata/ImageCard.Metadata';
export var ImageCard = Object.assign(_ImageCard, {
  Metadata: ImageCardMetadata
});